import { Components, isPlatform } from '@ionic/core';
import { IonIcon, IonItem } from '@ionic/react';
import { lockClosed } from 'ionicons/icons';
import { PaywallModalWrapper } from './paywall-modal-wrapper';
import { PaywallComponentBaseProps } from './paywall.types';

export interface PaywallIonItemProps extends PaywallComponentBaseProps {
  ionItemProps?: Partial<Components.IonItem> & {
    routerLink?: string | undefined;
  };
}

const PaywallIonItem = (props: PaywallIonItemProps) => {
  const { planEntitlementKey, isFeatureAvailable, ionItemProps, children } =
    props;

  return (
    <PaywallModalWrapper planEntitlementKey={planEntitlementKey}>
      {({ presentUpgrade, hasEntitlement }) => {
        const isAvailable = isFeatureAvailable
          ? isFeatureAvailable(hasEntitlement)
          : hasEntitlement;

        const isIOS = isPlatform('ios');

        return (
          <IonItem
            lines={'full'}
            detail={isAvailable && isIOS}
            {...ionItemProps}
            onClick={(e) => {
              if (!isAvailable) {
                e.stopPropagation();
                e.preventDefault();
                presentUpgrade();
              }
            }}
          >
            {children}
            {!isAvailable && (
              <IonIcon slot="end" icon={lockClosed} size="small" />
            )}
          </IonItem>
        );
      }}
    </PaywallModalWrapper>
  );
};

export { PaywallIonItem };
